module.exports = __webpack_public_path__ + "img/75734.0cb86f40.svg";